<template>
    <div class="photo-section">
        <div v-if="this.photoPreview.length > 0 || editMode">
            <div class="action-icons">
                <v-icon v-if="this.uploadedPhotos.length > 0"  class="download-icon" color="blue" large @click="downloadZip()">mdi-download</v-icon>
            </div>
            <div class="title"><h4 v-if="!editMode"> {{ title }} </h4></div>
            <v-progress-linear
                v-if="photoUploadProgress"
                class="progress mb-2"
                :color="progressColor"
                buffer-value="0"
                :value="photoUploadProgress"
                stream
            ></v-progress-linear>
            <div class = "form-group-fields">
                <v-file-input
                    v-if="editMode && this.photoUploadProgress === 0"
                    :rules="editMode ? rules: []"
                    accept="image/png, image/jpeg, image/bmp"
                    :placeholder="label"
                    prepend-icon="mdi-camera"
                    :clearable="clearable"
                    :label="label"
                    class="field"
                    multiple
                    counter
                    @change="onPhotosSelect"
                    :disabled="readOnly"
                ></v-file-input>
            </div>
            <div class="photo-preview-wrapper">
                <div v-if="this.photosLoaded < this.numberOfPhotos" class="loading-overlay">
                    <div class="loader" />Περιμένετε μέχρι οι φωτογραφίες να φορτώσουν..
                </div>
                <v-card
                    v-for="(photo, index) in this.photoPreview"
                    :key="index"
                    class="image-card"
                >
                    <v-img
                        :src="photo.url"
                        :max-width="$vuetify.breakpoint.xsOnly ? '300px' : '200px'"
                        :max-height="$vuetify.breakpoint.xsOnly ? '300px' : '200px'"
                        :min-width="$vuetify.breakpoint.xsOnly ? '300px' : '200px'"
                        :min-height="$vuetify.breakpoint.xsOnly ? '300px' : '200px'"
                        class="the-image"
                        @click="setPhotoToDisplay(index)"
                    >
                    </v-img>
                    <div
                        v-if="photo.url.startsWith('blob') && photoUploadProgress === 0"
                        class="image-delete"
                        @click="removePhotoFromUpload(photo)"
                    >Διαγραφή</div>
                    <div
                        v-else-if="photo.url.startsWith('https') && isAdminOrCompanyCoordinator && editMode"
                        class="image-delete"
                        @click="removeUploadedPhoto(photo)"
                    >Διαγραφή</div>
                </v-card>
                <div v-if="this.photoUploadProgress > 0" class="loading-overlay">
                    <div class="loader" />Περιμένετε μέχρι οι φωτογραφίες να ανέβουν..
                </div>
            </div>
            <v-dialog
                v-model="photoDialog"
                hide-overlay
                fullscreen
                content-class="photo-dialog"
                transition="fade-transition"
            >
                <div class="carousel-wrapper">
                    <div class="carousel-overlay-controls">
                        <v-btn @click="rotateLeft" class="overlay-btn"><v-icon>mdi-rotate-left</v-icon>Left</v-btn>
                        <v-btn @click="rotateRight" class="overlay-btn">Right <v-icon>mdi-rotate-right</v-icon></v-btn>
                    </div>

                    <v-btn
                        icon
                        class="exit-btn-overlay"
                        fab
                        small
                        @click="photoDialog = false"
                    >
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>

                    <v-carousel v-model="carouselImage" class="carousel" height="100%" show-arrows :hide-delimiters="$vuetify.breakpoint.xsOnly" dark>
                        <v-carousel-item
                            v-for="(photo, index2) in photoPreview"
                            :key="index2"
                            class="image-container"
                        >
                            <v-img class="image-carousel" :style="{ transform: `rotate(${rotation}deg)` }" :src="photo.url" height="100%" width="100%" contain/>
                        </v-carousel-item>
                    </v-carousel>
                </div>
            </v-dialog>
            <v-progress-linear
                v-if="photoUploadProgress"
                class="progress mt-2"
                :color="progressColor"
                buffer-value="0"
                :value="photoUploadProgress"
                stream
            ></v-progress-linear>
        </div>
        <div v-else class="photo-section">
            Δεν υπάρχουν φωτογραφίες  <span v-if="title"> στην ενότητα {{ this.title }}</span>
        </div>
    </div>
</template>

<script>
    import uploadService from '@/services/upload'
    import JSZip from 'jszip'
    import axios from 'axios'
    import { saveAs } from 'file-saver'
    const HETZNER_API_STORAGE_URL = process.env.VUE_APP_HETZNER_API_STORAGE_URL

    export default {
        props: {
            uploadedPhotos: {
                type: Array,
                required: true
            },
            readOnly: {
                type: Boolean,
                required: true
            },
            editMode: {
                type: Boolean,
                required: true
            },
            clearable: {
                type: Boolean,
                required: true
            },
            uploadPath: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: false,
                default: () => { return 'Ανέβασμα Φωτογραφιών' }
            },
            title: {
                type: String,
                required: false,
                default: () => { return '' }
            },
            zipName: {
                type: String,
                required: false,
                default: () => { return 'download' }
            }
        },
        watch: {
            photosToUpload: {
                handler(val, oldVal) {
                    this.$emit('photoSelection', this.photosToUpload)
                },
                deep: true
            },
            uploadedPhotos: {
                handler(val, oldVal) {
                    this.initPhotoPreview()
                },
                deep: true
            }
        },
        data() {
            return {
                photoPreview: [],
                photoUploadProgress: 0,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                carouselImage: null,
                photoDialog: false,
                dialog: false,
                photosToUpload: [],
                uploadedPhotosToDelete: [],
                numberOfPhotos: 0,
                photosLoaded: 0,
                rotation: 0,
                progressColor: '#0047AB'
            }
        },
        methods: {
            rotateLeft() {
                this.rotation -= 90
            },
            rotateRight() {
                this.rotation += 90
            },
            async downloadZip() {
                const zip = new JSZip()
                const folder = zip.folder('images')
                const downloadPromises = this.uploadedPhotos.map(async(url) => {
                    let photoUrl
                    if (this.isUrl(url)) {
                        photoUrl = url
                    } else {
                        photoUrl = HETZNER_API_STORAGE_URL + '/' + url
                    }
                    return axios
                        .get(photoUrl, {
                            headers: {
                                'Cache-Control': 'no-cache',
                                'Pragma': 'no-cache'
                            },
                            responseType: 'blob'
                        })
                        .then(response => {
                            let fileName = url.substring(url.lastIndexOf('/')).substring(1)
                            folder.file(fileName, response.data)
                        })
                        .catch(error => {
                            console.error(`Error fetching ${url}:`, error)
                        })
                })

                try {
                    await Promise.all(downloadPromises)
                    const content = await zip.generateAsync({ type: 'blob' })
                    saveAs(content, this.zipName + '.zip')
                } catch (error) {
                    console.error('Error generating ZIP:', error)
                }
            },
            onPhotosSelect(files) {
                this.photosLoaded = 0
                this.photosToUpload = []
                this.photosToUpload = Array.from(files)
                this.numberOfPhotos = this.photosToUpload.length
                this.photosToUpload = [...this.photosToUpload]
                this.initPhotoPreview()
            },
            isUrl(str) {
                try {
                    const url = new URL(str)
                    return url.protocol === 'http:' || url.protocol === 'https:'
                } catch {
                    return false
                }
            },
            removeUploadedPhoto(photo) {
                if (!this.isAdminOrCompanyCoordinator) return
                const index1 = this.photoPreview.findIndex(pp => pp.url === photo.url)
                this.photoPreview.splice(index1, 1)
                this.uploadedPhotosToDelete.push(photo)
            },
            initPhotoPreview() {
                this.photoPreview = []
                this.uploadedPhotos.forEach(photo => {
                    if (this.isUrl(photo)) {
                        this.photoPreview.push({ url: photo })
                    } else {
                        this.photoPreview.push({ url: HETZNER_API_STORAGE_URL + '/' + photo })
                    }
                })
                for (let photo of this.photosToUpload) {
                    const blobURL = URL.createObjectURL(photo)
                    const img = new Image()
                    img.onload = () => {
                        this.photoPreview.push({
                            url: blobURL, metadata: photo.name + photo.size + photo.type
                        })
                        this.photosLoaded++
                        this.photoPreview = [...this.photoPreview]
                    }
                    img.onerror = () => {
                        console.log('error')
                        URL.revokeObjectURL(blobURL)
                        const reader = new FileReader()
                        reader.onload = e => {
                            this.photoPreview.push({
                                url: e.target.result, metadata: photo.name + photo.size + photo.type
                            })
                            this.photosLoaded++
                            this.photoPreview = [...this.photoPreview]
                        }
                        reader.readAsDataURL(photo)
                    }
                    img.src = blobURL
                }
            },
            removePhotoFromUpload(photo) {
                this.dialog = false
                const index1 = this.photoPreview.findIndex(pp => pp.metadata === photo.metadata)
                this.photoPreview.splice(index1, 1)
                const index2 = this.photosToUpload.findIndex(ptu => ptu.name + ptu.size + ptu.type === photo.metadata)
                this.photosToUpload.splice(index2, 1)
                this.photoPreview = [...this.photoPreview]
            },
            setPhotoToDisplay(photoIndex) {
                this.carouselImage = photoIndex
                this.photoDialog = true
            },
            async uploadPhotos() {
                this.progressColor = '#0047AB'
                if (this.photosToUpload.length === 0) {
                    return
                }
                // CRITICAL iOS MEMORY FIX:
                // Revoke all Blob URLs and clear them from the DOM *before* XHR requests.
                // This forces WKWebView to garbage-collect the massive uncompressed graphics memory,
                // preventing the tab from running out of RAM and silently refreshing.
                this.photoPreview.forEach(pp => {
                    if (pp.url && pp.url.startsWith('blob:')) {
                        URL.revokeObjectURL(pp.url)
                    }
                })
                this.photoPreview = this.photoPreview.filter(pp => !pp.url.startsWith('blob:'))

                let uploadedPhotos = []
                this.photoUploadProgress = 0
                const perPhotoProgress = 100 / this.photosToUpload.length
                for (let photo of this.photosToUpload) {
                    let formData = new FormData()
                    formData.append('file', photo)
                    try {
                        this.photoUploadProgress += perPhotoProgress
                        const response = await uploadService.uploadPhoto(this.uploadPath, formData)
                        uploadedPhotos.push(response.content)
                        // CRITICAL iOS MEMORY FIX:
                        // const previewIndex = this.photoPreview.findIndex(pp => pp.metadata === photo.name + photo.size + photo.type)
                        // if (previewIndex) {
                        //     URL.revokeObjectURL(this.photoPreview[previewIndex].url)
                        // }
                    } catch (e) {
                        this.onPhotoUploadError(e)
                    }
                }
                this.photosToUpload = []
                this.photosLoaded = 0
                this.numberOfPhotos = 0
                this.photoUploadProgress = 0
                return uploadedPhotos
            },
            async deleteUploadedPhotos() {
                if (!this.isAdminOrCompanyCoordinator) return
                this.progressColor = 'red'
                if (this.uploadedPhotosToDelete.length === 0) {
                    return
                }
                let deletedPhotos = []
                this.photoUploadProgress = 0
                const perPhotoProgress = 100 / this.uploadedPhotosToDelete.length
                for (let photo of this.uploadedPhotosToDelete) {
                    try {
                        const photoKey = photo.url.replace(`${HETZNER_API_STORAGE_URL}/`, '')
                        this.photoUploadProgress += perPhotoProgress
                        await uploadService.deleteFile(photoKey)
                        deletedPhotos.push(photoKey)
                    } catch (e) {
                        this.onPhotoDeleteError(e)
                    }
                }
                this.uploadedPhotosToDelete = []
                this.photoUploadProgress = 0
                return deletedPhotos
            },
            onPhotoUploadError(e) {
                this.photoUploadProgress = 0
                throw Error('Κάτι πήγε στραβά. Ελένξτε τον τύπο του αρχείου. Αποδεκτές μορφές: .png, .jpg, .jpeg')
            },
            onPhotoDeleteError(e) {
                this.photoUploadProgress = 0
                throw Error('Κάτι πήγε στραβά στην Διαγραφή των φωτογραφιών')
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>

<style scoped>

.loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
}
.loader {
    margin-right: 0.5rem;
    min-width: 3rem;
    min-height: 3rem;
    transform: translateZ(0);
    box-sizing: border-box;
    width: 3rem;
    height: 3rem;
    border: 0.5em solid rgba(255, 255, 255, 0.3);
    border-top: 0.5rem solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.download-icon {
    cursor: pointer;
    margin-left: 0.1rem;
    transition: transform 0.2s ease-in-out;
}

.download-icon:hover {
    transform: translateY(-4px);
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3));
}

.progress {
    width: 95%;
    margin: 0 auto;
}

.photo-preview-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: left
}

.photo-section {
    border: solid 1px var(--cards-and-tables-text-color);
    padding: 1rem;
    border-radius: 5px;
    margin-bottom: 0.5rem;
    width: 100%;
}

.carousel {
    height: 100%;
    position: relative;
    background-color: rgba(0, 0, 0, 0.3) !important; /* semi-transparent */
    backdrop-filter: blur(15px)
}

.carousel-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: black;
}

.carousel-overlay-controls {
    position: absolute;
    top: 15px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 12px;
    z-index: 10000;
    pointer-events: none;
}

.overlay-btn {
    pointer-events: auto;
    background-color: black !important;
    color: white !important;
}

.exit-btn-overlay {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    z-index: 100;
    background: white !important;
}

.image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.image-carousel {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain !important;
    transition: transform 0.3s ease;
}

.image-card {
    border-radius: 10px;
    cursor: pointer;
    margin: 0.2rem;
    display: flex;
    flex-direction: column;
}

.the-image {
    margin: 0.3rem;
}

.image-delete {
    background-color: red;
    color: white;
    display: flex;
    justify-content: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.spacer {
    display: none;
}

.v-card__actions, .v-card__title {
    display: flex;
    justify-content: center;
}

.action-icons {
    position: absolute;
    right: 2.7rem;
    z-index: 1;
}

@media only screen and (max-width: 436px) {
  .photo-preview-wrapper {
        justify-content: center;
    }
}
</style>
<style>
.photo-dialog {
    top: 55px !important;
    height: calc(100vh - 55px) !important;
    align-items: flex-start !important;
}
</style>
